import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import axios from "axios";
import BASEURL from "../../Config/global";
import { setAccessToken } from "../../Util/authHeader";

import { useDispatch, useSelector } from "react-redux";
import { setUserDetails } from "../../Store/Slices/UserSlice";

import AuthLayout from "../../Layout/AuthLayout";
import CustomButton from "../../Components/CustomButton";
import CustomInput from "../../Components/CustomInput";

import "./style.css";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const ResetPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userPrompts = useSelector((state) => state.user.userPrompts);
  const { t } = useTranslation();

  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [succesModal, setSuccesModal] = useState(false);
  const [loginError, setLoginError] = useState({ error: false, text: "" });


  const handleClick = async (e) => {
    setLoading(false)
    e.preventDefault();
    const formDataToSend = new FormData();
    const userEmail = localStorage.getItem("user_email");

    formDataToSend.append("email", userEmail?.trim());
    formDataToSend.append("password", formData.password);

    try {
      debugger
      if (formData.password.length >=6) {
        const response = await axios.post(`${BASEURL}/api/user/reset_password/`, formDataToSend);
        if (!response.data.error) {
          setLoading(false)
          setSuccesModal(true);
          setTimeout(() => {
            setSuccesModal(false);
            navigate("/login");
          }, 1000);
        } else {
          setLoading(false)
        }
      } else {
        setLoading(false);
        setLoginError({
          error: true,
          text: userPrompts?.password_length_message || t("auth.signup.errors.passwordLength"),
        });
      }
    } catch (error) {
      console.log(error)
    }
  };

  return (
    <>
      <AuthLayout pagename="forgot-password">
        <h3 className="lightColor text-center fw-semibold text-uppercase m-0 mb-5">{t("auth.resetPassword.title")}</h3>
        <form>
          <div className="row">
            <div className="col-12">
              <CustomInput
                label={t("auth.resetPassword.passwordLabel")}
                required
                id="password"
                type="password"
                labelClass="mainLabel"
                inputClass="mainInput"
                onChange={(event) => {
                  setFormData({
                    ...formData,
                    password: event.target.value,
                  });
                }}
              />
            </div>
            {loginError.error === true && (
              <div className="col-12">
                <p className="smallText lightColor w-100 text-wrap">{loginError.text}</p>
              </div>
            )}
          </div>
          <div className="row mt-4 text-center">
            <div className="col-12">
              {
                loading ? (

                  <button className="primaryButton customButton">
                    <div className="spinner-border spinner-border-sm text-dark" role="status"></div>
                  </button>
                )
                  : (

                    <CustomButton
                      variant="primaryButton"
                      text={t("auth.resetPassword.submit")}
                      onClick={handleClick}
                    />
                  )
              }

            </div>
          </div>
        </form>
      </AuthLayout>

      {/* Success Modal */}
      <Modal
        show={succesModal}
        centered
        className="success-modal"
        backdrop="static"
      >
        <Modal.Body>
          <div className="my-5">
            <h2 className="font-16 lh-16 fw-normal my-5 text-center">{userPrompts?.reset_password_notification || t("auth.resetPassword.success")}</h2>
          </div>
        </Modal.Body>
      </Modal>

    </>
  );
};

export default ResetPassword;
